import api from '../../utils/api'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'
import { FaCreativeCommonsZero } from "react-icons/fa6";
import Checkbox from "../../shared/components/form/checkbox"
import Button from '../../shared/components/Button/Button'
import Modal from '../../shared/modal/Modal'
import ConfirmDeleteModal from '../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
/* Function */
import { monthYear, dayMonthYear, secondToHour, secondToMinute, secondToSecond } from "../../shared/functions/Date"

import "./EditHorimetro.css"
/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import useMyPermission from '../../hooks/useMyPermission'

import FormRecordHorimetro from './Components/form/FormRecordHorimetro'
import FormRecord from './Components/form/FormRecord'
import FormEvent from './Components/form/FormEvent'

//image
import iconMaterial from './img/iconMaterialBest.png'
import iconEmergencia from './img/iconEmergencia.png'
import iconHorario from './img/iconHorario.png'
import iconCritical from './img/iconCritical.png'
import iconNoNotification from './img/iconNoNotification.png'

const TABS = [
    { value: "event", label: "Eventos" },
    { value: "radiator", label: "Radiador" },
    { value: "battery", label: "Bateria" },
    { value: "pump", label: "Bomba injetora" },
    { value: "tank", label: "Limpeza de tanque" },
    { value: "megage", label: "Megagem de Alternador" },
    { value: "equipSanit", label: "Higienização de Equipamento" },
    { value: "horimetro", label: "Horímetro" },
]

function EditHorimetro() {
    const [client, setClient] = useState({})
    const [tab, setTab] = useState("horimetro")
    const [radiator, setRadiator] = useState([])
    const [changeBattery, setChangeBattery] = useState([])
    const [injectionPump, setInjectionPump] = useState([])
    const [tankCleaning, setTankCleaning] = useState([])
    const [alternatorMegages, setAlternatorMegages] = useState([])
    const [equipmentSanitizations, setEquipmentSanitizations] = useState([])
    const [horimetro, setHorimetro] = useState([])
    const [events, setEvents] = useState([])
    const [modalEditRecordRadiator, setModalEditRecordRadiator] = useState(false)
    const [modalEditRecordInjectionPump, setModalEditRecordInjectionPump] = useState(false)
    const [modalEditRecordChangeBattery, setModalEditRecordChangeBattery] = useState(false)
    const [modalEditRecordTankCleaning, setModalEditRecordTankCleaning] = useState(false)
    const [modalEditRecordAlternatorMegage, setModalEditRecordAlternatorMegage] = useState(false)
    const [modalEditRecordEquipmentSanitization, setModalEditRecordEquipmentSanitization] = useState(false)
    const [modalEditHorimetro, setModalEditHorimetro] = useState(false)
    const [modalEditEvent, setModalEditEvent] = useState(false)
    const [inputName, setInputName] = useState("")
    const [record, setRecord] = useState({})
    const [recordHorimetro, setRecordHorimetro] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    const { id } = useParams()
    const { setFlashMessage } = useFlashMessage()
    const [modalDelete, setModalDelete] = useState(false)
    const [modalDeleteInjectionPump, setModalDeleteInjectionPump] = useState(false)
    const [modalDeleteChangeBattery, setModalDeleteChangeBattery] = useState(false)
    const [modalDeleteTankCleaning, setModalDeleteTankCleaning] = useState(false)
    const [modalDeleteHorimetro, setModalDeleteHorimetro] = useState(false)
    const [pathDelete, setPathDelete] = useState("")

    const [myPermission, setMyPermission] = useState({ group: "", })
    //CHECK PERMISSIONS
    const { checkPermission } = useMyPermission()
    const myPermissionEdit = checkPermission(myPermission, "serviceExp_Edit")
    const myPermissionDelete = checkPermission(myPermission, "serviceExp_Delete")
    const myPermissionView = checkPermission(myPermission, "serviceExp_View")
    const myPermissionCreate = checkPermission(myPermission, "serviceExp_Create")

    useEffect(() => {

        api.get(`/clientServiceExpiration/getAll/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setMyPermission(response.data.permission)
            setClient(response.data.client)
            setRadiator(response.data.radiator)
            setChangeBattery(response.data.changeBattery)
            setInjectionPump(response.data.injectionPump)
            setTankCleaning(response.data.tankCleaning)
            setHorimetro(response.data.horimetro)
            setEvents(response.data.events)
            setAlternatorMegages(response.data.alternatorMegages)
            setEquipmentSanitizations(response.data.equipmentSanitizations)

        })
    }, [token, id])

    async function updateEvent(info) {
        let msgType = "success"
        const data = await api.patch(`event/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditEvent(false)
            api.get(`/event/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {
                setEvents(response.data.event)
            })

        }

    }
    async function updateAlternatorMegage(info) {
        let msgType = "success"
        const data = await api.patch(`alternatorMegage/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordAlternatorMegage(false)
            api.get(`/alternatorMegage/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {
                setAlternatorMegages(response.data.alternatorMegages)
            })

        }

    }

    async function updateRadiator(info) {
        let msgType = "success"
        const data = await api.patch(`radiator/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordRadiator(false)
            api.get(`/radiator/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {
                setRadiator(response.data.radiator)
            })

        }

    }
    async function updateEquipmentSanitization(info) {
        let msgType = "success"
        const data = await api.patch(`equipmentSanitization/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordEquipmentSanitization(false)
        }
        if (data.equipmentSanitizations) {
            setEquipmentSanitizations(data.equipmentSanitizations)
        }



    }
    async function updateChangeBattery(info) {
        let msgType = "success"
        const data = await api.patch(`changeBattery/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordChangeBattery(false)
            api.get(`/changeBattery/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {
                setChangeBattery(response.data.changeBattery)
            })

        }


    }
    async function updateInjectionPump(info) {
        let msgType = "success"
        const data = await api.patch(`injectionPump/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordInjectionPump(false)
            api.get(`/injectionPump/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {
                setInjectionPump(response.data.injectionPump)
            })
        }
    }
    async function updateTankCleaning(info) {
        let msgType = "success"
        const data = await api.patch(`tankCleaning/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditRecordTankCleaning(false)
            api.get(`/tankCleaning/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {

                setTankCleaning(response.data.tankCleaning)
            })
        }
    }
    async function updateHorimetro(info) {
        let msgType = "success"
        const data = await api.patch(`horimetro/${info._id}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalEditHorimetro(false)
            api.get(`/horimetro/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {

                setHorimetro(response.data.horimetro)
            })
        }
    }

    function handleOnDelete() {
        setModalDelete(true)
    }

    async function deleteRecord(info) {
        let msgType = "success"
        const data = await api.delete(`/${pathDelete}`, info, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType === "success") {
            setModalDelete(false)
            api.get(`/clientServiceExpiration/getAll/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token)}`,
                },

            }).then((response) => {

                setMyPermission(response.data.permission)
                setClient(response.data.client)
                setRadiator(response.data.radiator)
                setChangeBattery(response.data.changeBattery)
                setInjectionPump(response.data.injectionPump)
                setTankCleaning(response.data.tankCleaning)
                setHorimetro(response.data.horimetro)
                setEvents(response.data.events)
                setAlternatorMegages(response.data.alternatorMegages)
                setEquipmentSanitizations(response.data.equipmentSanitizations)

            })
        }
    }
    function handleChangeCheckbox(id) {

        let checkboxItem = client
        if ("overdueMaintenance" === id) {
            setClient({ ...checkboxItem, overdueMaintenance: !checkboxItem.overdueMaintenance })
        } if ("validMaintenance" === id) {
            setClient({ ...checkboxItem, validMaintenance: !checkboxItem.validMaintenance })
        } if ("materialBest" === id) {
            setClient({ ...checkboxItem, materialBest: !checkboxItem.materialBest })
        } if ("emergency" === id) {
            setClient({ ...checkboxItem, emergency: !checkboxItem.emergency })
        } if ("rushHour" === id) {
            setClient({ ...checkboxItem, rushHour: !checkboxItem.rushHour })
        } if ("critical" === id) {
            setClient({ ...checkboxItem, critical: !checkboxItem.critical })
        } if ("noNotification" === id) {
            setClient({ ...checkboxItem, noNotification: !checkboxItem.noNotification })
        }



    }

    async function updateClient(client) {
        let msgType = 'success'

        const data = await api.patch(`generator/update/${client._id}`, client, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)


    }

    return (
        myPermissionView ? (
            <section className="pg-page hor-edit-page">
                <div className="pg-sticky-top">
                    <div className="pg-header">
                        <div className="pg-header-title">
                            <p className="pg-title">{client.name}</p>
                            <span className="pg-title-accent" />
                        </div>
                    </div>
                </div>

                <div className="hor-edit-body">

                    <div className="hor-edit-operation-card">
                        <span className="hor-edit-operation-label">Modo de Operação</span>
                        {myPermissionEdit &&
                            <div className="hor-edit-operation-actions">
                                <Button variant="save" onClick={() => { updateClient(client) }}>Salvar</Button>
                            </div>
                        }
                        <div className="hor-edit-operation-field">
                            <div className="hor-edit-operation-grid">
                                <div className="hor-operation-row">
                                    <img className="hor-operation-icon" src={iconMaterial} alt="" />
                                    <Checkbox
                                        text="Gerador com material de revisão fornecido pela Bestforce"
                                        name="materialBest"
                                        check={client.materialBest}
                                        handleOnChange={() => { handleChangeCheckbox("materialBest") }}
                                    />
                                </div>
                                <div className="hor-operation-row">
                                    <img className="hor-operation-icon" src={iconEmergencia} alt="" />
                                    <Checkbox
                                        text="Emergência"
                                        name="emergency"
                                        check={client.emergency}
                                        handleOnChange={() => { handleChangeCheckbox("emergency") }}
                                    />
                                </div>
                                <div className="hor-operation-row">
                                    <img className="hor-operation-icon" src={iconHorario} alt="" />
                                    <Checkbox
                                        text="Horário de ponta"
                                        name="rushHour"
                                        check={client.rushHour}
                                        handleOnChange={() => { handleChangeCheckbox("rushHour") }}
                                    />
                                </div>
                                <div className="hor-operation-row">
                                    <img className="hor-operation-icon" src={iconCritical} alt="" />
                                    <Checkbox
                                        text="Gerador crítico"
                                        name="critical"
                                        check={client.critical}
                                        handleOnChange={() => { handleChangeCheckbox("critical") }}
                                    />
                                </div>
                                <div className="hor-operation-row">
                                    <img className="hor-operation-icon" src={iconNoNotification} alt="" />
                                    <Checkbox
                                        text="Desativar notificações"
                                        name="noNotification"
                                        check={client.noNotification}
                                        handleOnChange={() => { handleChangeCheckbox("noNotification") }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="hor-edit-tabs">
                        {TABS.map((t) => (
                            <button
                                key={t.value}
                                className={`hor-edit-tab ${tab === t.value ? 'hor-edit-tab-active' : ''}`}
                                onClick={() => { setTab(t.value) }}
                            >
                                {t.label}
                            </button>
                        ))}
                    </div>

                    <div className="hor-edit-records-wrap">

                    <div className="hor-edit-records">
                        {tab === "event" && (
                            events.length > 0 ? (
                                events.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{dayMonthYear(i.date)}</span>
                                            <span className="hor-record-value">{i.name}</span>
                                            <span className="hor-record-value hor-record-desc">{i.description}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditEvent(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`event/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "radiator" && (
                            radiator.length > 0 ? (
                                radiator.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordRadiator(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`radiator/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "battery" && (
                            changeBattery.length > 0 ? (
                                changeBattery.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordChangeBattery(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`changeBattery/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "pump" && (
                            injectionPump.length > 0 ? (
                                injectionPump.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordInjectionPump(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`injectionPump/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "tank" && (
                            tankCleaning.length > 0 ? (
                                tankCleaning.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordTankCleaning(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`tankCleaning/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "megage" && (
                            alternatorMegages.length > 0 ? (
                                alternatorMegages.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordAlternatorMegage(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`alternatorMegage/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "equipSanit" && (
                            equipmentSanitizations.length > 0 ? (
                                equipmentSanitizations.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            <span className="hor-record-value hor-record-value-strong">{monthYear(i.date)}</span>
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecord(i); setModalEditRecordEquipmentSanitization(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`equipmentSanitization/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}

                        {tab === "horimetro" && (
                            horimetro.length > 0 ? (
                                horimetro.map((i) => (
                                    <div key={i._id} className="pg-item">
                                        <div className="pg-item-main hor-record-fields">
                                            {i.reset && <FaCreativeCommonsZero className="hor-record-reset-icon" title="Horímetro zerado/trocado" />}
                                            <span className="hor-record-value hor-record-value-strong">{dayMonthYear(i.horimetroDate)}</span>
                                            <span className="hor-record-value">{`${secondToHour(i.horimetroRecordSeconds)}h ${secondToMinute(i.horimetroRecordSeconds)}min ${secondToSecond(i.horimetroRecordSeconds)}s`}</span>
                                            {i.changeOilAndFilter && <span className="hor-record-badge">Troca de óleo e filtro</span>}
                                        </div>
                                        <div className="shd-row-box-item-action">
                                            {myPermissionEdit &&
                                                <FaPencilAlt className="shd-icon-row-edit" title="Editar" onClick={() => { setRecordHorimetro(i); setModalEditHorimetro(true) }} />
                                            }
                                            {myPermissionDelete &&
                                                <FaTrashAlt className="shd-icon-row-trash" title="Apagar" onClick={() => { setPathDelete(`horimetro/${i._id}`); setModalDelete(true); }} />
                                            }
                                        </div>
                                    </div>
                                ))
                            ) : <div className="pg-empty"><p className="pg-empty-title">Não há registros cadastrados</p></div>
                        )}
                    </div>
                    </div>
                </div>

                {modalEditHorimetro &&
                    <FormRecordHorimetro data={recordHorimetro} closeModal={() => { setModalEditHorimetro(false) }} handleOnSubmit={updateHorimetro} />
                }
                {modalEditRecordTankCleaning &&
                    <FormRecord title="Limpeza de Tanque:" data={record} closeModal={() => { setModalEditRecordTankCleaning(false) }} handleOnSubmit={updateTankCleaning} />
                }
                {modalEditRecordAlternatorMegage &&
                    <FormRecord title="Megagem de Alternador:" data={record} closeModal={() => { setModalEditRecordAlternatorMegage(false) }} handleOnSubmit={updateAlternatorMegage} />
                }
                {modalEditRecordEquipmentSanitization &&
                    <FormRecord title="Higienização de Equipamento:" data={record} closeModal={() => { setModalEditRecordEquipmentSanitization(false) }} handleOnSubmit={updateEquipmentSanitization} />
                }
                {modalEditRecordRadiator &&
                    <FormRecord title="Radiador Sist. Arr.:" data={record} closeModal={() => { setModalEditRecordRadiator(false) }} handleOnSubmit={updateRadiator} />
                }
                {modalEditRecordChangeBattery &&
                    <FormRecord title="Troca de Bateria:" data={record} closeModal={() => { setModalEditRecordChangeBattery(false) }} handleOnSubmit={updateChangeBattery} />
                }
                {modalEditRecordInjectionPump &&
                    <FormRecord title="Revisão de Bomba Injetora:" data={record} closeModal={() => { setModalEditRecordInjectionPump(false) }} handleOnSubmit={updateInjectionPump} />
                }
                <Modal
                    modalStatus={modalEditEvent}
                    changeStatus={setModalEditEvent}
                    w={38}
                    h={52}
                    t={15}
                    content={
                        <FormEvent data={record} handleOnSubmit={updateEvent} />
                    }

                />

                <ConfirmDeleteModal
                    modalStatus={modalDelete}
                    changeStatus={setModalDelete}
                    onConfirm={() => deleteRecord()}
                    message="Deseja realmente excluir esse registro?"
                />
            </section>
        ) : (
            <div></div>
        )
    )
}
export default EditHorimetro
